module.exports = __webpack_public_path__ + "static/media/edit-alt.56897987.svg";